import { createSelector } from '@reduxjs/toolkit';
import { EStarRating } from '../../../../packages/JsonQuery';
import { selectStarRating } from 'shared/selectors/jsonQuery';

const STAR_RATING_OPTIONS = [
  {
    label: 'Без звёзд',
    value: EStarRating.NoRating,
  },
  {
    label: '1 звезда',
    value: EStarRating.Star1,
  },
  {
    label: '2 звезды',
    value: EStarRating.Star2,
  },
  {
    label: '3 звезды',
    value: EStarRating.Star3,
  },
  {
    label: '4 звезды',
    value: EStarRating.Star4,
  },
  {
    label: '5 звёзд',
    value: EStarRating.Star5,
  },
];

export const selectStarRatingFilter = createSelector(selectStarRating, value => ({
  value,
  label: 'Количество звёзд',
  options: STAR_RATING_OPTIONS,
}));
